import { Icon } from 'common/icon';
import { ITagData, ITagColor } from 'constants/types';
import React from 'react';

const defaultColor = '#CCCCCC';
const defaultTextColor = 'black';

export const getColor = (tag: string, colors: ITagColor) => {
  return colors?.[tag] || defaultColor;
};

export const getColorForTag = (tag: string, tagData: ITagData) => {
  return tagData?.[tag]?.color || defaultColor;
};

export const getIconForTag = (tag: string, tagData: ITagData) => {
  return tagData?.[tag]?.icon;
};

export const getTextColorForTag = (tag: string) => {
  const normalizedTag = tag.toLowerCase();

  if (normalizedTag === 'blacklisted') {
    return 'white';
  }
  return defaultTextColor;
};

export const getCategoryIcon = (category?: string): React.ReactNode => {
  switch (category) {
    case 'Topics':
    case 'Casino complaint':
      return React.createElement(Icon.Shield);
    case 'News':
      return React.createElement(Icon.News, { width: 14, height: 14 });
    default:
      return null;
  }
};
